import { Box, Flex, Skeleton } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { usePlanPageRevampVariant } from 'pages/PlanRevamp/PlanPageUIRevamp/usePlanPageUiRevamp';
import {
  PLAN_PROPERTY_CARD_SHADOW,
  PLAN_PROPERTY_CARD_WIDTH,
} from 'pages/PlanRevamp/PlanPageUIRevamp/planInputPanelTheme';
import { getPlanPageThemeColors } from 'redux/ThemeSlice';

interface Properties {
  variant?: 'legacy' | 'revamp';
}

const SkeletonLoader = ({ variant = 'legacy' }: Properties) => {
  const isRevamp = usePlanPageRevampVariant(variant);
  const themeColors = useSelector(getPlanPageThemeColors);

  return (
    <Flex
      className={isRevamp ? undefined : 'dimension'}
      mr={isRevamp ? 0 : '15px'}
      flexDirection='column'
      minW={isRevamp ? PLAN_PROPERTY_CARD_WIDTH : '310px'}
      w={isRevamp ? PLAN_PROPERTY_CARD_WIDTH : undefined}
      flexShrink={0}
      alignSelf='flex-start'
      alignItems='flex-start'
      backgroundColor={isRevamp ? themeColors.surface : 'rgba(67, 64, 111, 0.5)'}
      border={isRevamp ? '1px solid' : 'none'}
      borderColor={isRevamp ? themeColors.border : undefined}
      boxShadow={isRevamp ? PLAN_PROPERTY_CARD_SHADOW : undefined}
      borderRadius={isRevamp ? '12px' : '18px'}
      mb={isRevamp ? 0 : '15px'}
      padding={isRevamp ? '12px' : '5px 10px 0 10px'}
      maxWidth={isRevamp ? PLAN_PROPERTY_CARD_WIDTH : { base: '400px', md: '400px' }}
    >
      <Box width='100%' pt={isRevamp ? 0 : 1} pb={isRevamp ? 0 : '1.5rem'}>
        <Skeleton
          height='20px'
          width='100%'
          mb='1.5rem'
          startColor={isRevamp ? 'gray.100' : undefined}
        />
        <Skeleton
          height='62px'
          width='100%'
          mb='10px'
          startColor={isRevamp ? 'gray.100' : undefined}
        />
        <Skeleton height='20px' width='100%' startColor={isRevamp ? 'gray.100' : undefined} />
      </Box>
    </Flex>
  );
};

export default SkeletonLoader;
